import React from "react";
import Carousel from "./Carousel";

const Features = ({isDesktopView}) => {
  return (
    <div style={{background:"black"}} className="features">
      <div className="features__header">
        <div className="features__header--heading">
        STILL NOT IMPRESSED?
        </div>
        <div className="features__header--content">
        Check out these successful Teacherpreneurs
        </div>
      </div>
      <div className="features__content">
        <Carousel isDesktopView={isDesktopView} />
      </div>
    </div>
  );
};

export default Features;
